import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const dashBoardService = {
    getTravelGraphData: (data) => {
        return axios.post(`${baseUrl}/employee-analytics/travel-analysis`, data)
    },
    getTravelSummaryData: () => {
        return axios.get(`${baseUrl}/geo-locations/dashboard-card`)
    }
}

export default dashBoardService